import { fromJS, Map, List } from 'immutable';
import { FAVORITES_LOAD, FILTER_RESET, FILTER_UPDATE } from './actionTypes';
import { START, SUCCESS, ERROR } from '../../consts';

const DEFAULT_STATE_FILTER = new Map({
  page: 1,
  'per-page': 30,
  sort: null,
  isMls: null
});

const DEFAULT_STATE = fromJS({
  loading: false,
  loaded: false,
  error: null,
  filter: DEFAULT_STATE_FILTER,
  favoriteList: [],
  meta: {
    seoTitle: '',
    seoDescription: ''
  },
  links: {}
});

export default function favorites (state = DEFAULT_STATE, action) {
  switch (action.type) {
    case FILTER_RESET:
    case FILTER_UPDATE:
      const filter = filterReducer(state.get('filter'), action);
      return state.mergeIn(['filter'], filter);

    case FAVORITES_LOAD + START:
      return state.merge({
        loading: true,
        favoriteList: new List(),
        error: null
      });

    case FAVORITES_LOAD + SUCCESS:
      return state.merge(action.payload, {
        loading: false,
        loaded: true,
        favoriteList: action.items,
        meta: action.meta
      });

    case FAVORITES_LOAD + ERROR:
      return state.merge({
        loaded: false,
        favoriteList: new List(),
        error: action.payload
      });

    default:
      return state;
  }
};

/**
 * Reducer для фильтра избранного
 * @param state
 * @param action
 * @returns {*}
 */
function filterReducer (state = DEFAULT_STATE_FILTER, action) {
  switch (action.type) {
    case FILTER_RESET:
      return DEFAULT_STATE_FILTER;
    case FILTER_UPDATE:
      return state.merge(action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/Favorites/reducer.js